module.exports = __webpack_public_path__ + "img/empty-state.a5a2d325.svg";